import { cx } from 'class-variance-authority';
import { get } from 'lodash';
import type { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { helperTextClassNames, labelClassNames } from '~/components/ui/Form/StyledInput';

interface FormularTextareaInputProps {
    name: string;
    label?: ReactNode;
    helperText?: string;
    placeholder?: string;
    rows?: number;
}

// Multiline text field wired into react-hook-form; visually matches StyledInput (label, error, helper text).
const FormularTextareaInput = ({ name, label, helperText, placeholder, rows = 4 }: FormularTextareaInputProps) => {
    const {
        register,
        formState: { errors }
    } = useFormContext();
    const error = get(errors, name);
    const isInvalid = !!error;

    return (
        <div className="tw-my-1 tw-w-full">
            {label && (
                <label htmlFor={'input_' + name} className={labelClassNames({ isInvalid })}>
                    {label}
                </label>
            )}
            <textarea
                {...register(name)}
                id={'input_' + name}
                rows={rows}
                placeholder={placeholder}
                className={cx(
                    'tw-block tw-w-full tw-resize-y tw-rounded-xl tw-border tw-border-solid tw-px-2 tw-py-2 tw-text-sm tw-outline-none tw-transition-colors',
                    isInvalid
                        ? 'tw-border-transparent tw-bg-errorLight focus:tw-border-error'
                        : 'tw-border-transparent tw-bg-accents-0 focus:tw-border-success'
                )}
            />
            {(error?.message || helperText) && (
                <span className={helperTextClassNames({ isInvalid })}>{(error?.message as string) || helperText}</span>
            )}
        </div>
    );
};

export default FormularTextareaInput;
